import { FiCheckSquare, FiSquare } from 'react-icons/fi';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.css';
import { toClassName } from '../../utils/toClassName';
import Clickable from '../Buttons/Clickable';

const Checkbox = ({ selected, onClick, size }) => {
  const Icon = selected ? FiCheckSquare : FiSquare;
  const className = toClassName(styles.container, selected && styles.checked);

  return (
    <Clickable onClick={onClick} className={className}>
      <Icon size={size} />
    </Clickable>
  );
};

Checkbox.propTypes = {
  selected: PropTypes.bool,
  size: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  selected: false,
  size: 18,
};

export default Checkbox;
